import React from "react";
import Spinner from "@atlaskit/spinner";

interface UFOLoadingSpinnerProps {
  interactionName: string;
  label?: string;
  size?: "xsmall" | "small" | "medium" | "large" | "xlarge";
  testId?: string;
}

export function UFOLoadingSpinner({
  interactionName,
  label,
  size = "medium",
  testId,
}: UFOLoadingSpinnerProps): React.JSX.Element {
  return <Spinner interactionName={interactionName} label={label} size={size} testId={testId} />;
}
